export default "__VITE_ASSET__DQGbYWCF__"